import type { LearnerTitle } from "../Data/reportData";
import emergingLeaderImg from "../../../../../../assets/archetypes/emerging-leader.png";
import strategicLeaderImg from "../../../../../../assets/archetypes/strategic-leader.png";
import visionaryLeaderImg from "../../../../../../assets/archetypes/visionary-leader.png";

interface TitleBadgeProps {
  title: LearnerTitle;
  learnerName: string;
}

const titleGradients: Record<LearnerTitle, string> = {
  "Emerging People Leader": "linear-gradient(to right, #2FB9FF, #6BFFCF)",
  "Effective People Leader": "linear-gradient(to right, #2FB9FF, #6BFFCF)",
  "Impact‑Driven People Leader": "linear-gradient(to right, #2FB9FF, #6BFFCF)",
};

const frameColors: Record<LearnerTitle, { border: string; glow: string }> = {
  "Emerging People Leader": { border: "border-purple/30", glow: "from-purple/20 to-violet/20" },
  "Effective People Leader": { border: "border-purple/40", glow: "from-purple/25 to-violet/25" },
  "Impact‑Driven People Leader": { border: "border-violet-400/50", glow: "from-violet-400/30 to-fuchsia-400/30" },
};

const archetypeImages: Record<LearnerTitle, string> = {
  "Emerging People Leader": emergingLeaderImg,
  "Effective People Leader": strategicLeaderImg,
  "Impact‑Driven People Leader": visionaryLeaderImg,
};

const dividerColors: Record<LearnerTitle, string> = {
  "Emerging People Leader": "rgba(31, 228, 208, 0.4)",
  "Effective People Leader": "rgba(31, 228, 208, 0.4)",
  "Impact‑Driven People Leader": "rgba(107, 255, 207, 0.4)",
};

export function TitleBadge({ title, learnerName }: TitleBadgeProps) {
  const gradientStyle = titleGradients[title];
  const frame = frameColors[title];
  const archetypeImage = archetypeImages[title];
  const isVisionary = title === "Impact‑Driven People Leader";
  const dividerColor = dividerColors[title];
  
  return (
    <div className="flex flex-col items-center gap-4">
      {/* Archetype Image */}
      <div className="relative">
        <div className={`absolute -inset-2 rounded-full bg-gradient-to-r ${frame.glow} blur-lg opacity-60`} />
        <div className={`relative w-32 h-32 rounded-full overflow-hidden border-2 ${frame.border} shadow-lg`}>
          <img 
            src={archetypeImage} 
            alt={title}
            className="w-full h-full object-cover object-top"
          />
        </div>
      </div>
      
      {/* Title badge */}
      <div className="flex flex-col items-center">
        <h2
          className="text-xl font-bold tracking-[0.25em] uppercase bg-clip-text text-transparent"
          style={{
            backgroundImage: gradientStyle,
            ...(isVisionary ? { textShadow: '0 0 20px rgba(107,255,207,0.4)' } : {}),
          }}
        >
          {title}
        </h2>
        <div
          className="w-12 h-0.5 mx-auto mt-2 rounded-full"
          style={{ background: `linear-gradient(to right, transparent, ${dividerColor}, transparent)` }}
        />
      </div>
    </div>
  );
}
